import script from "./MealTypeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MealTypeModal.vue?vue&type=script&setup=true&lang=js"

import "./MealTypeModal.vue?vue&type=style&index=0&id=343713df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-343713df"]])

export default __exports__